module.exports = __webpack_public_path__ + "static/inviteBtn.29e85d58.png";